import { GlobalProvider } from './context/GlobalProvider';
import Pages from './pages/Pages';

import './App.scss';

function App() {
    return (
        <GlobalProvider>
            <Pages />
        </GlobalProvider>
    )
}

export default App